import { Grid, withStyles } from "@material-ui/core";
import { inject, observer } from "mobx-react";
import { withSnackbar } from "notistack";
import React from "react";
import {
  getShipperErrorInfo,
  getPickupDateTimeErrorInfo,
  getTerminalFieldError,
  getSearchFieldError,
  getShipperPickupWindow,
  getlatestReadyCloseTime,
} from "./ShipperInfo/utils";
import {
  getShipmentErrorInfo,
  checkAtLeastOneShipmentInvalid,
  getDefaultShipment
} from "./ShipmentInfo/utils";
import { getEditReasonErrorInfo } from "./EditReasonInfo/utils";
import { withUserProfile } from "../../../../../../userProfile/userProfileContext";
import { compose } from "recompose";
import { postData } from "../../../../../../api/componentAPIs";
import appConstants from "../../../../../../appConstants";
import { AppLoading } from "../../../../../../loaders/loaders";
import Events from "../../../../../../utilities/EventEmitter";
import PickupTypeToggles from "./components/PickupTypeToggles";
import BillingForm from "./Billing";
import PanelAction from "./components/Action";
import ErrorContainer from "./components/Error";
import WithModal from "./components/WithModal";
import { PICKUP_MANAGEMENT_CONFIG } from "./config";
import {
  PICKUP_MANAGEMENT_MODES,
  WARNING_DETAILS,
  ORDERERD_FIELD_LIST,
  FORM_VALIDATION_MSG,
} from "./constants";
import ShipmentInfoForm from "./ShipmentInfo";
import ShipperInfoForm from "./ShipperInfo";
import PickupInfo from "./ShipperInfo/PickupInfo";
import {
  getConfirmationButtonLabel,
  getDefaultPickupManagementErrorInfo,
  getDefaultPickupManagementInfo,
  getSavePickupMessage,
  checkIsDateTimeUpdated,
  getSelectedTerminalDetails,
  isReadOnlyPickupViewMode,
  isMergePickupMode,
  getFormattedShippers,
  getFormattedTerminals,
  fetchTerminalAndRestrictionsData,
  getCombinedSpecialInstructions,
  getFirstSelectedAssignedDriverPickup,
  getShipperByPickupId,
  validateToggle,
  isCreateOrEditPickupMode,
} from "./utils";
import { getDuplicatePickupCheckerParams } from "./DuplicatePickupChecker/utils";
import EditReasonForm from "./EditReasonInfo";
import VoidPickup from "./VoidPickupInfo";
import UnvoidPickup from "./UnvoidPickupInfo";
import DuplicatePickupChecker from "./DuplicatePickupChecker";
import { getDefaultVoidPickData, getErrorInfo } from "./VoidPickupInfo/utils";
import Warning from "./components/Warning";
import SelectShipperForm from "./MergePickupShipperDetails"
import DriverDetails from "./MergePickupShipperDetails/DriverDetails"
import { isEqual, isObject } from "lodash/lang";
import { withFeatureFlags } from "../../../../../../userProfile/featureFlagsContext";
import { withAppConfig } from "../../../../../../appConfigContext";
import { getDefaultUnvoidPickData } from "./UnvoidPickupInfo/utils";
import { DRIVER_EVENTS } from "../../constants";
import { RMAXLogger } from "../../../../../../services/LoggerService/RMAXLogger";
import cloneDeep from "lodash/cloneDeep";
import NoFreightInfo from "./NoFreightInfo";
import { APP_EVENT_NAMES } from "../../../../../../signalR/constants";
const { DISPATCH } = APP_EVENT_NAMES;
import { getDefaultNoFreightInfo, getNoFreightErrorInfo } from "./NoFreightInfo/utils";
import { convertDateTimeToTimeString } from '@dataGrid/gridUtilities';
import { isNotAssignedPickup } from "../../filterUtils";
import { sortShipmentsBySeq } from "../utils";
import RequiresLG from "./components/RequiresLG";
import { sanitizeObject } from "../../../../../../utilities/dataUtils";
const styles = (theme) => ({
  dialogMainContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: '100%'
  },
  contentContainer: {
    overflowY: 'auto',
    overflowX: 'hidden',
    paddingTop: 16,
    height: '100%'
  },
  leftPanelContainer: {
    marginTop: 8
  },
  rightPanelContainer: {
    paddingRight: 24
  },
  actionContainer: {
    display: 'flex',
    flexDirection: 'row',
    padding: '8px 24px 24px 24px',
    flex: 1,
    justifyContent: 'flex-end'
  },
  toggleErrorMessage: {
    color: theme.errorBorderColor,
    fontSize: theme.dispatchCardTextFontSize,
    marginLeft: 4,
    marginBottom : 8
  },
  detailsColumnWise: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
  },
});

@inject("DispatchStore")
@observer
class PickupManagementForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      isDateTimeUpdated: false,
      terminals: [],
      selectedTerminal: null,
      selectedTerminalError: null,
      selectedTerminalOffset: null,
      searchFieldError: null,
      pickupInfo: null,
      pickupErrorInfo: getDefaultPickupManagementErrorInfo(),
      voidPickup: getDefaultVoidPickData(),
      unvoidPickup: getDefaultUnvoidPickData(),
      noFreightPickup: getDefaultNoFreightInfo(),
      error: null,
      hasWarning: false,
      overrideWarning: false,
      isShipperSearched : false,
      selectedShipper : "",
      shipperList : [],
      selectedDriver : null,
      driverRoute : null,
      pickupData: null,
      shipmentGridError: appConstants.GRID_STATUS.SUCCESS,
      isConfirmButtonDisabled: false,
      isExhibitPickupInMergeMode: this.isExhibitPickupInMergeMode(),
    };
    this.pickupRestrictionsData = [];
    this.pickupRestrictedTerminals = [];
    this.isMiscellaneousAccountCode = false;
    this.warning = null;
    this.timer = null;
    this.enablePickupEdit = this.props.featureFlags.isFeatureEnabled(
      appConstants.features.EnablePickupEdit
    );
    this.enablePickupGrouping = this.props.featureFlags.isFeatureEnabled(
      appConstants.features.EnablePickupGrouping
    );
    this.logs = [];
    this.isReadOnlyPickupMergeMode = this.enablePickupGrouping && isMergePickupMode(this.props.mode);
    if(this.isReadOnlyPickupMergeMode){
      this.logs.push({action: "MergingPickups", data: JSON.stringify(this.props.pickupData.map(p=> p.pickupId))});
    }
    this.shipmentInfo = [];
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      !isReadOnlyPickupViewMode(this.props.mode) &&
      (prevState.selectedTerminal !== this.state.selectedTerminal ||
        prevState.pickupInfo?.shipperInfo !==
          this.state.pickupInfo?.shipperInfo ||
        prevState.pickupInfo?.shipmentInfo !==
          this.state.pickupInfo?.shipmentInfo)
    ) {
      this.pickupRestrictionsValidation();
    }
    if (
      isMergePickupMode(this.props.mode) &&
      this.state.selectedShipper &&
      !isEqual(
        this.props.pickupData,
        prevProps.pickupData
      )
    ) {
      this.refreshShipperList(this.getFormattedPickupData([]));
    } else if (
      this.props.mode === PICKUP_MANAGEMENT_MODES.NO_FREIGHT_PICKUP &&
      !isEqual(this.props.pickupData, prevProps.pickupData)
    ) {
      this.setState({
        isConfirmButtonDisabled: !isNotAssignedPickup({
          pickup: this.props.pickupData,
          terminalOffset: this.state.selectedTerminalOffset
        })
      });
    }
  }

  refreshShipperList = (pickupData) => {
    const { selectedPossibleMergePickupId } = this.props;
    const selectedShipper = JSON.parse(this.state.selectedShipper);
    const isNoLongerDuplicatePickup = pickupData.find(
      (pickup) =>
        pickup.pickupId?.toLowerCase() !==
        selectedShipper.pickupId.toLowerCase()
    );
    const shipperList = getFormattedShippers(pickupData, selectedPossibleMergePickupId);
    if (isNoLongerDuplicatePickup) {
      const firstAssignPickupSelected =
        getFirstSelectedAssignedDriverPickup(pickupData);
      const selectedPickupData = this.getMergePickupInitialData(
        firstAssignPickupSelected ?? pickupData[0],
        pickupData
      );
      this.setState({
        pickupInfo: getDefaultPickupManagementInfo(
          selectedPickupData,
          this.state.selectedTerminalOffset
        ),
        shipperList,
        selectedShipper: getShipperByPickupId(shipperList, selectedPickupData.pickupId),
        selectedDriver: firstAssignPickupSelected?.driverId,
        pickupData: this.getFormattedPickupData(this.state.pickupData)
      });
      this.updateIsMiscShipper(
        selectedPickupData?.shipperAccountNumber,
        selectedPickupData?.isMiscellaneousShipper
      );
    } else {
      this.setState({ shipperList });
    }
    this.setShipmentInfo();
  };

  isExhibitPickupInMergeMode = () => {
    if (!isMergePickupMode(this.props.mode)) {
      return false;
    }
    return this.props.pickupData.some(pickup => pickup.isExhibitPickup);
  }

  getShipmentByPickupId = (pickupId, shipmentData) => {
    if (shipmentData?.length === 0) {
      return [];
    }
    const pickup = shipmentData.find((pickup) => pickup.pickupId.toUpperCase() === pickupId.toUpperCase());
    return pickup ? pickup.shipments : [];
  };

  getFormattedPickupData = (responseData) => {
    if (!this.props.pickupData) {
      return this.props.pickupData;
    }
    if (isMergePickupMode(this.props.mode)) {
      return this.props.pickupData.map((pickup) => ({
        ...pickup,
        shipments: this.getShipmentByPickupId(pickup.pickupId, responseData)
      }));
    } else {
      return {
        ...this.props.pickupData,
        shipments: this.getShipmentByPickupId(this.props.pickupData.pickupId, responseData)
      };
    }
  };

  getPickupShipments = (pickupId) => {
    this.setState({ shipmentGridError: appConstants.GRID_STATUS.LOADING });
    this.logs.push({action: "Requesting Pickup Shipments"});
    return postData('GetPickupShipments', {
      terminalCode: this.props.userData.userProfile.terminal.code,
      pickupIds: pickupId
    }).then(
      (response) => {
        if (response && response.status === 200) {
          const pickupData = this.getFormattedPickupData(response.data);
          this.shipmentInfo = [];
          if (isMergePickupMode(this.props.mode)) {
            let shipmentData = pickupData.map((pickup) => pickup.shipments).flat();
            shipmentData = sortShipmentsBySeq(shipmentData);
            this.shipmentInfo = shipmentData.map((shipment) => getDefaultShipment(shipment)) || [];
            
            this.logs.push({action: "getPickupShipments", data: JSON.stringify(this.shipmentInfo)});
          } else {
            let shipmentData = sortShipmentsBySeq(pickupData.shipments);
            this.shipmentInfo = shipmentData.map((shipment) => getDefaultShipment(shipment)) || [];
          }
          this.setState((prevState) => ({
            pickupInfo: {
              ...prevState.pickupInfo,
              shipmentInfo:cloneDeep(this.shipmentInfo)
            },
            pickupData,
            shipmentGridError: appConstants.GRID_STATUS.SUCCESS
          }));
        } else {
         this.handleGetPickupShipmentsFailure();
        }
      },
      (error) => {
        this.handleGetPickupShipmentsFailure();
      }
    );
  };

  handleGetPickupShipmentsFailure = () => {
    this.logs.push({action: "Requesting Pickup Shipments : Failed"});
    this.shipmentInfo = [];
    const pickupData = this.getFormattedPickupData([]);
    this.setState({ pickupData, shipmentGridError: appConstants.GRID_STATUS.ERROR });
  }

  setShipmentInfo = () => {
    if (isMergePickupMode(this.props.mode)) {
      if (this.props.pickupData.some((pickup) => pickup.bills > 0)) {
        this.getPickupShipments(this.props.pickupData.map((pickup) => pickup.pickupId));
      } else {
        this.logs.push({action: "skipGetShipments", data: JSON.stringify(this.props.pickupData.map((p =>({pickupId: p.pickupId,bills: p.bills}))))});
      }
    } else if (this.props.pickupData?.bills) {
      this.getPickupShipments([this.props.pickupData.pickupId]);
    }
  };

  initializeAllData = (pickupData) => {
    const { mode, userData, DispatchStore, selectedPossibleMergePickupId } = this.props;
    if (isReadOnlyPickupViewMode(mode)) {
      this.initializeVoidPickupData(pickupData);
      this.setShipmentInfo();
    } else {
      this.loadPickupMgmntStaticData().then(({ terminals, pickupRestrictions }) => {
        let terminalsData = terminals;
        if (isMergePickupMode(mode) || this.isEditMode()) {
          terminalsData = terminals.filter((terminal) => {
            return [
              userData.userProfile.terminal.code,
              ...DispatchStore.movePickupTerminalList
            ].includes(terminal.terminalCode);
          });
        }
        let shipperList = [],
          selectedPickupData,
          selectedDriver = null;
        if (isMergePickupMode(mode)) {
          const firstAssignPickupSelected = getFirstSelectedAssignedDriverPickup(pickupData);
          selectedPickupData = this.getMergePickupInitialData(
            firstAssignPickupSelected ?? pickupData[0],
            pickupData
          );
          shipperList = getFormattedShippers(pickupData, selectedPossibleMergePickupId);
          selectedDriver = firstAssignPickupSelected?.driverId;
        } else {
          selectedPickupData = pickupData;
        }
        this.initializeCommonPickupMgmntData({
          selectedPickupData,
          shipperList,
          pickupRestrictions,
          terminalsData,
          selectedDriver
        });
        this.setShipmentInfo();
      });      
    }    
  };

  componentDidMount() {
    const pickupData = this.getFormattedPickupData([]);
    this.setState(
      {
        pickupData
      },
      () => {
        this.initializeAllData(pickupData);
      }
    );
    if(isReadOnlyPickupViewMode(this.props.mode)){
      if (this.props.mode === PICKUP_MANAGEMENT_MODES.NO_FREIGHT_PICKUP) {
        Events.on(DISPATCH.NoFreightForUnassignedPickup, this.checkReadOnlyPickupViewStatus);
      } else {
        Events.on(DISPATCH.VoidAndUnvoidPickup, this.checkReadOnlyPickupViewStatus);
      }
    }
    if(isMergePickupMode(this.props.mode)){
      Events.on(DISPATCH.MergePickups, this.checkMergePickupStatus);
    }
    
    RMAXLogger.info("Pickup_Management", {
      action: "Viewed",
    });
  }

  componentWillUnmount() {
    Events.removeListener(DISPATCH.VoidAndUnvoidPickup, this.checkReadOnlyPickupViewStatus);
    Events.removeListener(DISPATCH.MergePickups, this.checkMergePickupStatus);
    Events.removeListener(
      DISPATCH.NoFreightForUnassignedPickup,
      this.checkReadOnlyPickupViewStatus
    );
    
    // Clear timer if exists
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
    
    // Clear instance properties to prevent memory leaks
    this.pickupRestrictionsData = null;
    this.pickupRestrictedTerminals = null;
    this.shipmentInfo = null;
    this.logs = null;
  }

  loadPickupMgmntStaticData = () => {
    const { DispatchStore, userData } = this.props;
    if(DispatchStore.terminals.length && DispatchStore.pickupRestrictions){
      return Promise.resolve({
        terminals : DispatchStore.terminals.slice(),
        pickupRestrictions : DispatchStore.pickupRestrictions.data
      });
    }
    return fetchTerminalAndRestrictionsData(
      userData.userProfile.terminal.code
    ).then(([terminalListRes, pickupRestrictionsRes]) => {
      DispatchStore.setTerminals(terminalListRes.data);
      DispatchStore.setPickupRestrictions({ data: pickupRestrictionsRes.data });
      return {
        terminals: terminalListRes.data ?? [],
        pickupRestrictions: pickupRestrictionsRes.data ?? [],
      };
    });
  }

  initializeVoidPickupData = (pickupData) => {
    const { userData } = this.props;
    this.setState({
      pickupInfo: getDefaultPickupManagementInfo(
        pickupData,
        userData.userProfile.terminal.offset
      ),
      selectedTerminal: userData.userProfile.terminal.code,
      selectedTerminalOffset: userData.userProfile.terminal.offset,
    });
    this.updateIsMiscShipper(
      pickupData.shipperAccountNumber,
      pickupData.isMiscellaneousShipper
    )
  }

  initializeCommonPickupMgmntData = ({
    selectedPickupData,
    shipperList,
    pickupRestrictions,
    terminalsData,
    selectedDriver
  }) => {
    const terminals = getFormattedTerminals(terminalsData);
    const selectedTerminal = getSelectedTerminalDetails(
      selectedPickupData?.terminalCode ?? this.props.userData.userProfile.terminal.code,
      terminals
    );
    this.pickupRestrictionsData = pickupRestrictions;
    this.pickupRestrictedTerminals = this.pickupRestrictionsData.map(
      (eachObj) => eachObj.terminalCode
    );
    this.setState({
      terminals,
      pickupInfo: getDefaultPickupManagementInfo(
        selectedPickupData,
        selectedTerminal.offset
      ),
      selectedTerminal: selectedTerminal.value,
      selectedTerminalOffset: selectedTerminal.offset,
      shipperList,
      selectedShipper: getShipperByPickupId(shipperList, selectedPickupData?.pickupId),
      selectedDriver
    });
    this.updateIsMiscShipper(
      selectedPickupData?.shipperAccountNumber,
      selectedPickupData?.isMiscellaneousShipper
    );
  }

  getMergePickupInitialData = (selectedPickup = {}, selectedPickupsList = []) => {   
    const combinedSpecialInstructions = getCombinedSpecialInstructions(
      selectedPickupsList.map((pickup) => pickup.specialInstructions)
    );
    return {
      ...selectedPickup,
      ...getlatestReadyCloseTime(selectedPickupsList),
      specialInstructions : combinedSpecialInstructions,
      shipments : selectedPickupsList.map(pickup=>pickup.shipments).flat(),
      isLiftGate : selectedPickupsList.some(pickup => pickup.isLiftGate)
    }
  }

  getTerminalInputRef = (terminalRef) => {
    this.terminalRef = terminalRef;
  }

  getInitialPickupZipCodes = () => {
    return (
      this.state.pickupData?.shipments?.map(
        (shipment) => shipment.consigneeZip ?? ""
      ).filter(Boolean) ?? []
    );
  }


  updateIsMiscShipper = (shipperAccountNumber, isMiscellaneousShipper) => {
    this.isMiscellaneousAccountCode =
      !Boolean(shipperAccountNumber) || isMiscellaneousShipper;
  };

  checkReadOnlyPickupViewStatus = (data) => {
    if(!this.state.isLoading){ // checks if we had submitted data & waiting for from signalR
      return;
    }
    const { success, message, pickupId } = data;
    if (
      this.state.pickupData.pickupId.toUpperCase() !== pickupId?.toUpperCase()
    ) {
      return;
    }
    let actionType = "Void";
    if (this.props.mode === PICKUP_MANAGEMENT_MODES.UNVOID_PICKUP) {
      actionType="Unvoid";
    } else if (this.props.mode === PICKUP_MANAGEMENT_MODES.NO_FREIGHT_PICKUP) {
      actionType="No Freight";
    }
    if (success) {
      this.props.enqueueSnackbar(`${actionType} Pickup Successful.`, {
        variant: "success",
      });
      this.props.handleClose();
    } else {
      this.props.enqueueSnackbar(`${actionType} Pickup Failed`, {
        variant: "error",
      });
      this.setState((prevState) => ({
        ...prevState,
        isLoading: false,
        error: message.error,
      }));
    }
    clearTimeout(this.timer);
  }

  checkMergePickupStatus = (data) => {
    if(!this.state.isLoading){ // checks if we had submitted data & waiting for response
      return;
    }
    const { success } = data;
    const currentPickupIds = this.state.pickupData.map(p => p.pickupId.toUpperCase());
    const eventPickupIds = data.mergedPickupIds.map(id => id.toUpperCase());

    // if current merge pickupIds contain atleast 1 pickupId not present in merge pickupId then we can retain the popup
    if(!currentPickupIds.filter(pickupId => eventPickupIds.includes(pickupId)).length){
      return;
    }
    const { successMsg, errorMsg } = getSavePickupMessage(this.props.mode);
    if (success) {
      this.props.enqueueSnackbar(successMsg, {
        variant: "success",
      });

      // Deselecting all the pickups in the grid 
      this.props.resetGridSelections();
      
      this.props.handleClose();
    } else {
      this.props.enqueueSnackbar(errorMsg, {
        variant: "error",
      });
      this.setState({
        isLoading: false,
      });
    }
    clearTimeout(this.timer);
  };

  handleTerminalChange = (selectedTerminal) => {
    const selectedTerminalValue = selectedTerminal
      ? selectedTerminal.value
      : null;
    this.setState({
      selectedTerminal: selectedTerminalValue,
      selectedTerminalOffset: selectedTerminal ? selectedTerminal.offset : null,
      selectedTerminalError: getTerminalFieldError(selectedTerminalValue),
      searchFieldError: getSearchFieldError(selectedTerminalValue),
    });
  };

  updateFormData = (name, formData, formErrorData) => {
 
    this.logs.push({action: "userupdatedShipments", data: JSON.stringify(formData)});
    this.setState(
      (prevState) => ({
        pickupInfo: {
          ...prevState.pickupInfo,
          [name]: formData,
        },
        pickupErrorInfo: {
          ...prevState.pickupErrorInfo,
          [name]: formErrorData,
        },
      }),
      () => {
        if (name === "pickupDateTimeInfo" && this.isEditMode()) {
          this.setState({
            isDateTimeUpdated: checkIsDateTimeUpdated(
              this.state.pickupData,
              this.state.pickupInfo.pickupDateTimeInfo,
            ),
          });
        } 
      }
    );
  };


  isEditMode = () => {
    return this.props.mode === PICKUP_MANAGEMENT_MODES.EDIT_PICKUP;
  };

  onGridReady = (gridApi) => {
    this.gridApi = gridApi;
  };

  isPickupDataValid = () => {
    const {pickupDateTimeInfo } = this.state.pickupInfo;
    const pickupDateTimeErrorInfo = getPickupDateTimeErrorInfo({
      pickupDateTimeInfo,
      readyTime: pickupDateTimeInfo.readyTime,
      terminalOffset: this.state.selectedTerminalOffset,
      mode: this.props.mode,
    });
    this.setState((prevState) => ({
      pickupErrorInfo: {
        ...prevState.pickupErrorInfo,
        pickupDateTimeInfo: pickupDateTimeErrorInfo,
      },
    }));
    const pickupError = Object.values({
      ...pickupDateTimeErrorInfo,
    }).filter((value) => value).length;
    return Boolean(!pickupError);
  }

  isShipperDataValid = () => {
    if(this.isDisabledEditShipper()){
      return true;
    }
    const { shipperInfo, pickupDateTimeInfo } = this.state.pickupInfo;
    const shipperErrorInfo = getShipperErrorInfo(
      shipperInfo,
      pickupDateTimeInfo.readyTime,
    );
    this.setState((prevState) => ({
      pickupErrorInfo: {
        ...prevState.pickupErrorInfo,
        shipperInfo: shipperErrorInfo,
      },
    }));
    const shipperError = Object.values({
      ...shipperErrorInfo,
    }).filter((value) => value).length;
    return Boolean(!shipperError);
  };

  isShipmentDataValid = () => {
    const { shipmentInfo } = this.state.pickupInfo;
    const shipmentErrorInfoList = getShipmentErrorInfo(
      shipmentInfo,
      this.props.mode
    );
    this.setState((prevState) => ({
      pickupErrorInfo: {
        ...prevState.pickupErrorInfo,
        shipmentInfo: shipmentErrorInfoList,
      },
    }));
    const shipmentError = shipmentErrorInfoList.some((errorInfo) =>
      checkAtLeastOneShipmentInvalid(errorInfo),
    );
    if (shipmentError) {
      this.gridApi.isDataUpdatedOnGrid = true;
      this.gridApi.refreshCells();
    }
    return Boolean(!shipmentError);
  };

  isEditReasonDataValid = () => {
    const { editCodeList = [] } = this.props.DispatchStore.staticClientData?.clientCodes ?? {};
    const { editReasonInfo } = this.state.pickupInfo;
    const editReasonErrorInfo = getEditReasonErrorInfo(
      editReasonInfo,
      this.state.isDateTimeUpdated,
      editCodeList
    );
    this.setState((prevState) => ({
      pickupErrorInfo: {
        ...prevState.pickupErrorInfo,
        editReasonInfo: editReasonErrorInfo,
      },
    }));
    const editReasonError = Object.values({
      ...editReasonErrorInfo,
    }).filter((value) => value).length;
    return Boolean(!editReasonError);
  };

  isZipCodeInPickupRestrictionZipList = (zipCode, terminalCode) => {
    return (
      this.pickupRestrictionsData
        .find((zipObj) => zipObj.terminalCode === terminalCode)
        ?.zips.includes(zipCode) ?? false
    );
  };


  isShipperRestrictedZipCode = () => {
    return this.isZipCodeInPickupRestrictionZipList(
      this.state.pickupInfo.shipperInfo.shipperZip,
      this.state.selectedTerminal,
    );
  };

  isTerminalInPickupRestrictedList = (terminalCode) => {
    return this.pickupRestrictedTerminals.includes(terminalCode);
  };

  getRestrictedTerminalForShipper = () => {
    return this.isTerminalInPickupRestrictedList(this.state.selectedTerminal)
      ? this.state.selectedTerminal
      : "";
  };

  getRestrictedTerminalsForShipment = () => {
    const restrictedDestinationTerminalList = [];
    const initialShipmentZipcodes = this.getInitialPickupZipCodes();
    this.state.pickupInfo.shipmentInfo.forEach((shipment) => {
      if (
        !initialShipmentZipcodes.includes(shipment.destinationZip) && // if shipment zipcodes do not belong to zipcodes used while creating the pickup
        this.isZipCodeInPickupRestrictionZipList(
          shipment.destinationZip,
          shipment.destinationTerminal
        )
      ) {
        restrictedDestinationTerminalList.push(shipment.destinationTerminal);
      }
       
    });
    return [...new Set(restrictedDestinationTerminalList)];
  };

  validateShipperWarning = () => {
    const matchedRestrictedTerminal = this.getRestrictedTerminalForShipper();
    if (
      matchedRestrictedTerminal &&
      this.isMiscellaneousAccountCode &&
      this.isShipperRestrictedZipCode()
    ) {
      return {
        hasWarning: true,
        label: `${matchedRestrictedTerminal} ${WARNING_DETAILS.SHIPPER_LABEL}`,
        description: WARNING_DETAILS.SHIPPER_DESCRIPTION,
      };
    }
    return { hasWarning: false };
  };

  validateShipmentWarning = () => {
    const matchedRestrictedZipCodeTerminals = this.getRestrictedTerminalsForShipment();
    if (matchedRestrictedZipCodeTerminals.length > 0) {
      return {
        hasWarning: true,
        label: `${matchedRestrictedZipCodeTerminals.join(", ")} ${
          WARNING_DETAILS.DESTINATION_LABEL
        }`,
        description: WARNING_DETAILS.DESTINATION_DESCRIPTION,
      };
    }
    return { hasWarning: false };
  };

  setWarningDetails = (warningDetails) => {
    const { label, description, hasWarning } = warningDetails;
    this.warning = {
      label,
      description,
    };
    this.setState({ hasWarning });
  };

  pickupRestrictionsValidation = () => {
    const shipperWarningDetails = this.validateShipperWarning();
    if (shipperWarningDetails.hasWarning) {
      this.setWarningDetails(shipperWarningDetails);
      return;
    }
    const shipmentWarningDetails = this.validateShipmentWarning();
    if (shipmentWarningDetails.hasWarning) {
      this.setWarningDetails(shipmentWarningDetails);
      return;
    }
    this.setWarningDetails({
      hasWarning: false,
      label: "",
      description: "",
    });
  };

  handleSubmit = () => {
    const {
      pickupInfo,
      selectedTerminal,
      isDateTimeUpdated,
      hasWarning,
      overrideWarning,
      selectedDriver,
      pickupErrorInfo,
      isExhibitPickupInMergeMode,
    } = this.state;
    const { pickupId, pickupNumber } = this.state.pickupData ?? {};
    const isShipperDataValid = this.isShipperDataValid();
    const isShipmentDataValid = this.isShipmentDataValid();
    const isPickupDataValid = this.isPickupDataValid();
    const isEditReasonDataValid = isDateTimeUpdated
      ? this.isEditReasonDataValid()
      : true;
    if (
      isShipperDataValid &&
      isShipmentDataValid &&
      isPickupDataValid &&
      isEditReasonDataValid &&
      selectedTerminal &&
      !pickupErrorInfo.swapAndDrop &&
      !(hasWarning && !overrideWarning) //processing shipment will not be allowed if there is warning and not overridden
    ) {
      const selectedPickups = isMergePickupMode(this.props.mode) ? this.state.pickupData : null;
      
      const requestParams = PICKUP_MANAGEMENT_CONFIG[
        this.props.mode
      ].getRequestParams(
        {
          pickupData: {
            pickupInfo: pickupInfo,
            pickupTerminal: selectedTerminal,
            userProfile: this.props.userData.userProfile,
            pickupId,
            pickupNumber,
            isDateTimeUpdated,
          },
          selectedPickups,
          selectedDriver,
          isExhibitPickupInMergeMode
        }
      );
      const apiName = PICKUP_MANAGEMENT_CONFIG[this.props.mode].apiName;
      if(isMergePickupMode(this.props.mode)){
        this.logs.push({action: "onSubmitShipmentData", data: JSON.stringify(pickupInfo?.shipmentInfo ?? null)});
        RMAXLogger.info(`Merge Pickup Logs`,{
          pickupIds: this.props.pickupData.map(p => p.pickupId),
          terminalCode: this.props.userData.userProfile.terminal.code,
          logs:this.logs,
          isToBeReviewed : this.props.pickupData.map(p => ({pickupId:p.pickupId, isToBeReviewed: p.isToBeReviewed})),
        });
        this.mergePickups(apiName, requestParams);
      } else {
        this.savePickupData(apiName, requestParams);
      }
      
    } else {
      this.setState(
        { 
          error: null,
        },
        () => setTimeout(this.focusOnFirstInputWithError)
      );
    }
  };

  focusOnFirstInputWithError = () => {
    const {
      selectedTerminalError,
      pickupErrorInfo: {
        shipperInfo,
        pickupDateTimeInfo,
        editReasonInfo,
        swapAndDrop,
      },
    } = this.state;
    if (selectedTerminalError) {
      return this.terminalRef?.current?.focus();
    }
    const errorInfo = {
      ...shipperInfo,
      ...pickupDateTimeInfo,
      ...editReasonInfo,
      swapAndDrop,
    };
    const fieldToFocus = this.getFirstInputWithError(
      ORDERERD_FIELD_LIST,
      errorInfo
    );
    if (['editReasonCode', 'swapAndDrop'].includes(fieldToFocus)) {
      return document.getElementById(fieldToFocus)?.scrollIntoView();
    }
    this.focusOnFieldById(fieldToFocus);
  }

  getFirstInputWithError = (orderedFieldList,errorInfo) => {
    return orderedFieldList.find(field => errorInfo[field]);
  }

  focusOnFieldById = (fieldId) => {
    document.getElementById(fieldId)?.focus();    
  }

  isShipmentsModified =(requestParams)=>{
      const requestParamsShipments = cloneDeep(requestParams.shipmentData).map((shipment) => {
        delete shipment.sequenceNumber;
        return shipment;
      });
      return !isEqual(this.shipmentInfo, requestParamsShipments);
  }

   savePickupData = (apiName, requestParams) => {
    if (this.isEditMode()) {
      const areShipmentsModified =this.isShipmentsModified(requestParams)
      requestParams = { ...requestParams, areShipmentsModified };
     if(this.props.pickupData?.isToBeReviewed){
        RMAXLogger.info("Edit To Be Reviewed Pickup Data", {
          pickupId: this.props.pickupData.pickupId,
          isToBeReviewed: this.props.pickupData.isToBeReviewed,
        });
      }
    }
    this.setState({
      isLoading: true,
      error: null,
    });
    const { successMsg, errorMsg } = getSavePickupMessage(this.props.mode);
    postData(apiName, sanitizeObject(requestParams)).then(
      (response) => {
        if (response && Math.trunc(response.status / 100) === 2) {
          this.props.enqueueSnackbar(successMsg, {
            variant: "success",
          });
          this.props.handleClose();

          this.setState({
            isLoading: false,
          });
        } else {
          this.handleSavePickupDataError({
            errorMsg,
            error: response?.response?.data?.error?.message || response?.response?.data?.error?.message?.error?.error?.message,
            statusCode: response.status
          });
        }
      },
      () => {
        this.handleSavePickupDataError();
      }
    );
  };

  handleSavePickupDataError = ({error=null, errorMsg="", statusCode}) => {
    this.setState({
      isLoading: false,
      error: isObject(error) ? JSON.stringify(error) : error, // Stringify the error if it's an object, otherwise use it as is
    });
    if (statusCode === 403) {
      return;
    }
    this.props.enqueueSnackbar(errorMsg, {
      variant: "error",
    });
  }

  updateSpecialInstructions = ({
    specialInstructions,
    pickupDate,
    pickupWindow,
  }) => {
    const shipperDayOfWeekComments = getShipperPickupWindow(
      new Date(pickupDate),
      pickupWindow
    )?.additionalComment;
    const combinedSpecialInstructions = [
      specialInstructions,
      shipperDayOfWeekComments,
    ];
    this.setState((prevState) => ({
      pickupInfo: {
        ...prevState.pickupInfo,
        specialInstructions : getCombinedSpecialInstructions(combinedSpecialInstructions),
      },
    }));
  };

  updateSelectedShipperDataOnSearch = ({
    specialInstructions,
    shipperInfo,
    pickupDateTimeInfo,
    isMiscellaneousShipper,
    isShipperSearched,
    isLiftGate,
  }) => {
    if (isMergePickupMode(this.props.mode) && !isShipperSearched) {
      this.handleShipperSelection(this.state.selectedShipper); //  if Searched Shipper is cleared select previously selectd shipper in radio selections in case of merge pickup flow.
      this.setState({ isShipperSearched });
      return;
    }
      const shipperErrorInfo = getShipperErrorInfo(
        shipperInfo,
        pickupDateTimeInfo.readyTime
      );
      const pickupDateTimeErrorInfo = getPickupDateTimeErrorInfo({
        pickupDateTimeInfo,
        readyTime: pickupDateTimeInfo.readyTime,
        terminalOffset: this.state.selectedTerminalOffset,
      });
    this.updateIsMiscShipper(
      shipperInfo.shipperAccountNumber,
      isMiscellaneousShipper,
    );
    this.setState(
      (prevState) => ({
        pickupInfo: {
          ...prevState.pickupInfo,
          pickupDateTimeInfo,
          shipperInfo,
          isSwapPickup: false,
          isDockDropPickup: false,
          isExhibitPickup: false,
          isLiftGate
        },
        pickupErrorInfo: {
          ...prevState.pickupErrorInfo,
          shipperInfo: shipperErrorInfo,
          pickupDateTimeInfo: pickupDateTimeErrorInfo,
        },
        isShipperSearched,
      }),
      () =>
        this.updateSpecialInstructions({
          specialInstructions,
          pickupDate: pickupDateTimeInfo.pickupDate,
          pickupWindow: shipperInfo.pickupWindow,
        })
    );
    this.updateIsMiscShipper(
      shipperInfo.shipperAccountNumber,
      isMiscellaneousShipper
    );
  };

  updateToggleError = ({ isSwapPickup, isDockDropPickup }) => {
    this.setState((prevState) => ({
      pickupErrorInfo: {
        ...prevState.pickupErrorInfo,
        swapAndDrop: validateToggle({
          isSwapPickup,
          isDockDropPickup
        })
      }
    }));
  };

  handlePickupTypeToggle = (field) => (value) => {
    if (field === 'isExhibitPickupInMergeMode') {
      this.setState({
        [field]: value
      })
      return;
    }
    this.updateFormData(field, value, this.state.pickupErrorInfo);
    const { isSwapPickup, isDockDropPickup } = this.state.pickupInfo;
    this.updateToggleError({
      isDockDropPickup,
      isSwapPickup,
      [field]: value
    });
  };

  handleKeyDown = (event , callback) => {
    if (event?.keyCode === 37) {
      // keyCode: 37, leftArrow Key pressed (disable switch). keyCode: 39, rightArrow Key pressed (enable switch)
      callback(false);
    } else if (event?.keyCode === 39) {
      callback(true);
    }
  };

  handleKeyDownPickTypeToggle = (event) => {
    this.handleKeyDown(event, this.handlePickupTypeToggle);
  };

  handleNoFreightPickupSubmit = () => {
    const {
      noFreightPickup,
      noFreightPickup: { errorInfo },
    } = this.state;
    const { pickupId } = this.state.pickupData;
    const newErrorInfo = getNoFreightErrorInfo(errorInfo, noFreightPickup);
    this.setState((prevState) => ({
      ...prevState,
      noFreightPickup: {
        ...prevState.noFreightPickup,
        errorInfo: newErrorInfo,
      },
    }));
    const error = Object.values(newErrorInfo).filter((value) => value).length;
    if(error){
      const fieldToFocus = this.getFirstInputWithError(
        ORDERERD_FIELD_LIST,
        newErrorInfo
      );
      return this.focusOnFieldById(fieldToFocus)
    }
    if (!error) {
      const { contactName, callTime, comments } = noFreightPickup;
      const noFreightPickupData = {
        pickupId,
        terminalCode: this.props.userData.userProfile.terminal.code,
        contactName,
        callTime: convertDateTimeToTimeString(callTime),
        comments,
      };
      this.setState(
        (prevState) => ({
          ...prevState,
          isLoading: true,
          error: null,
        }),
        this.onPickupManagementProgressTimeOut,
      );
      RMAXLogger.info("No_Freight_Pickup", {
        action: "No_Freight_Pickup Clicked",
        payload: noFreightPickupData,
        isToBeReviewed : this.props.pickupData.isToBeReviewed,
      });
      this.submitData("NoFreightPickup", noFreightPickupData);
    }
  };

  handleVoidPickupSubmit = () => {
    const {
      voidPickup,
      voidPickup: { errorInfo },
    } = this.state;
    const { pickupId } = this.state.pickupData;
    const newErrorInfo = getErrorInfo(errorInfo, voidPickup);
    this.setState((prevState) => ({
      ...prevState,
      voidPickup: {
        ...prevState.voidPickup,
        errorInfo: newErrorInfo,
      },
    }));
    const error = Object.values(newErrorInfo).filter((value) => value).length;
    if(error){
      return this.focusOnFieldById("comment")
    }
    if (!error) {
      const { voidReason, comment } = voidPickup;
      const voidData = {
        pickupId,
        terminalCode: this.props.userData.userProfile.terminal.code,
        voidReason,
        comment,
      };
      this.setState(
        (prevState) => ({
          ...prevState,
          isLoading: true,
          error: null,
        }),
        this.onPickupManagementProgressTimeOut,
      );
      RMAXLogger.info("Void_Pickup", {
        action: "Void_Pickup Clicked",
        payload: voidData,
        isToBeReviewed : this.props.pickupData.isToBeReviewed,
      });
      this.submitData("VoidPickup", voidData);
    }
  };

  handleUnvoidPickupSubmit = () => {
    const {
      unvoidPickup,
      unvoidPickup: { errorInfo },
    } = this.state;
    const { pickupId } = this.props.pickupData;
    const newErrorInfo = getErrorInfo(errorInfo, unvoidPickup);
    this.setState((prevState) => ({
      ...prevState,
      unvoidPickup: {
        ...prevState.unvoidPickup,
        errorInfo: newErrorInfo,
      },
    }));
    const error = Object.values(newErrorInfo).filter((value) => value).length;
    if(error){
      return this.focusOnFieldById("comment")
    }
    if (!error) {
      const { comment } = unvoidPickup;
      const unvoidData = {
        pickupId,
        terminalCode: this.props.userData.userProfile.terminal.code,
        comment,
      };
      this.setState(
        (prevState) => ({
          ...prevState,
          isLoading: true,
          error: null,
        }),
        this.onPickupManagementProgressTimeOut,
      );
      RMAXLogger.info("Unvoid_Pickup Clicked", {
        action: "Unvoid_Pickup",
        payload: unvoidData,
        isToBeReviewed : this.props.pickupData.isToBeReviewed,
      });
      this.submitData("UnvoidPickup", unvoidData);
    }
  };

  mergePickups = (apiName, requestParams) => {
    this.setState(
      {
        isLoading: true,
        error: null
      },
      this.onPickupManagementProgressTimeOut
    );
    const areShipmentsModified = this.isShipmentsModified(requestParams);
    this.submitData(apiName, { ...requestParams, areShipmentsModified});
  };

  submitData = (apiName, requestParams) => {
    postData(apiName, sanitizeObject(requestParams)).then(
      (response) => {
        if (response && Math.trunc(response.status / 100) === 2);
        else {
          const apiErrorMsg = response?.response?.data?.error?.message || response?.response?.data?.error?.details;
          this.handleError({apiErrorMsg, statusCode: response.status});
        }        
      },
      () => {
        this.handleError();
      }
    );
  }

  handleError = ({apiErrorMsg = null, statusCode}) => {
    clearTimeout(this.timer);
    this.setState({
      isLoading: false,
      error: apiErrorMsg,
    });
    if (statusCode === 403) {
      return;
    }
    const { errorMsg } = getSavePickupMessage(this.props.mode);
    this.props.enqueueSnackbar(errorMsg, {
      variant: "error",
    });
  };

  updateVoidPickup = (voidPickupData) => {
    this.setState({
      voidPickup: voidPickupData,
    });
  };

  updateUnvoidPickup = (unvoidPickupData) => {
    this.setState({
      unvoidPickup: unvoidPickupData,
    });
  };

  updateNoFreightPickup = (noFreightPickupData) => {
    this.setState({
      noFreightPickup: noFreightPickupData,
    });
  };

  onPickupManagementProgressTimeOut = () => {
    this.timer = setTimeout(() => {
      this.setState({ isLoading: false });
    }, appConstants.ONE_MINUTE_TIME_OUT);
  };

  onSubmitButtonClicked = () => {
    const { mode } = this.props;
    if (isReadOnlyPickupViewMode(mode)) {
      if (mode === PICKUP_MANAGEMENT_MODES.NO_FREIGHT_PICKUP) {
        return this.handleNoFreightPickupSubmit
      }
      return mode === PICKUP_MANAGEMENT_MODES.VOID_PICKUP
        ? this.handleVoidPickupSubmit
        : this.handleUnvoidPickupSubmit;
    } else {
      return this.handleSubmit;
    }
  };

  handleShipperSelection = (selectedShipperData) => {
    const selectedShipper = JSON.parse(selectedShipperData)
    const selectedPickupData = this.state.pickupData.find(
      (pickup) =>
        pickup.rmaxShipperCode === selectedShipper.rmaxShipperCode &&
        pickup.pickupId === selectedShipper.pickupId
    );
    const pickupInfo = getDefaultPickupManagementInfo(
      this.getMergePickupInitialData(selectedPickupData, this.state.pickupData)
    );
    const shipperErrorInfo = getShipperErrorInfo(
      pickupInfo.shipperInfo,
      pickupInfo.pickupDateTimeInfo.readyTime
    );
    const pickupDateTimeErrorInfo = getPickupDateTimeErrorInfo({
      pickupDateTimeInfo : pickupInfo.pickupDateTimeInfo,
      readyTime: pickupInfo.pickupDateTimeInfo.readyTime,
      terminalOffset: this.state.selectedTerminalOffset,
    });
    this.setState((prevState) => ({
      pickupInfo,
      selectedShipper: selectedShipperData,
      pickupErrorInfo: {
        ...prevState.pickupErrorInfo,
        shipperInfo: shipperErrorInfo,
        pickupDateTimeInfo: pickupDateTimeErrorInfo,
      },
    }));
    this.handleDriverChange({ value: selectedPickupData.driverId });
    this.updateIsMiscShipper(
      selectedPickupData.shipperAccountNumber,
      selectedPickupData.isMiscellaneousShipper
    );
  }

  onToggleWarningOverride = () => {
    this.setState((prevState) => ({
      ...prevState,
      overrideWarning: !prevState.overrideWarning,
    }));
  };

  handleDriverChange = (option) => {
    const driverId = option ? option.value : null;
    const routeList = this.props.DispatchStore.currentActiveRoutes.slice();
    const driverRoute = driverId
      ? routeList.find((route) => route.driverId === driverId)
      : null;
    this.setState({
      selectedDriver: driverId,
      driverRoute,
    });
  }

  isDriverArrivedAtStop = (driverRoute) => {
    return driverRoute?.currentStatus?.status === DRIVER_EVENTS.ArrivedAtStop;
  };

  isDriverArrivedAtMergePickupStop = () => {
    const assignedPickups = this.props.pickupData.filter(pickup=>pickup.driverId);
    if(!assignedPickups.length){
      return false;
    }
    return assignedPickups.some(pickup=>{
      const driverId = pickup.driverId;
      const { routesList } = this.props.DispatchStore;
      const driverRoute = routesList.find((route) => route.driverId === driverId);
      if (!this.isDriverArrivedAtStop(driverRoute)) {
        return false;
      }
      const arrivedPickupStop = driverRoute.stops
        .filter((stop) => stop.stopType === appConstants.STOP_TYPE.Pickup)
        .find((stop) => stop.stopId === driverRoute.currentStatus.stopId);
      return pickup.pickupId.toUpperCase() === arrivedPickupStop?.pickupId.toUpperCase();
    })
  }

  isDisabledConfirmButton = ({ isMergePickupModeSelected, isDriverArrivedAtMergePickupStop }) => {
    if (this.state.isConfirmButtonDisabled) {
      return true
    }
    const { shipperList, hasWarning, overrideWarning, shipmentGridError } = this.state;
    return (
      [appConstants.GRID_STATUS.ERROR].includes(shipmentGridError) ||
      (hasWarning && !overrideWarning) ||
      (isMergePickupModeSelected && (shipperList.length < 2 || isDriverArrivedAtMergePickupStop))
    ); /* min 2 shipper required for merge */
  };

  getSelectedPickupsByIds = (duplicatePickupIds) => {
    return duplicatePickupIds.map(
      (pickupId) => this.props.DispatchStore.getPickupData(pickupId)
    ).filter(Boolean);
  }

  isMergePickupEditingAllowed = () => {
    return this.enablePickupEdit || !this.props.configJSON.enableMergePickup; // added for smt to disable edit shipper info
  }

  isDisabledEditShipper = () => {
    const { configJSON, mode } = this.props;
    const shipperInfo = this.state.pickupInfo?.shipperInfo;
    const isMisc = shipperInfo?.isMiscellaneousShipper;
  
    // Miscellaneous shippers are always editable
    if (isMisc) return false;
  
    // In Merge Pickup mode
    if (isMergePickupMode(mode)) {
      if (this.isMergePickupEditingAllowed()) {
        return !configJSON.enablePickupShipperEdit;
      }

      return true; // Default to disabled if editing is not allowed
    }
  
    // Non-merge mode: use config flag directly
    return !configJSON.enablePickupShipperEdit;
  };


  render() {
    const { handleClose, classes, mode } = this.props;
    const {
      terminals,
      selectedTerminal,
      pickupInfo,
      pickupErrorInfo,
      isDateTimeUpdated,
      error,
      selectedTerminalOffset,
      selectedTerminalError,
      searchFieldError,
      overrideWarning,
      hasWarning,
      shipperList,
      selectedShipper,
      isShipperSearched,
      selectedDriver,
      driverRoute,
      pickupData,
      shipmentGridError
    } = this.state;
    const showBillingForm = [
      PICKUP_MANAGEMENT_MODES.CREATE_PICKUP,
      PICKUP_MANAGEMENT_MODES.EDIT_PICKUP,
      PICKUP_MANAGEMENT_MODES.VOID_PICKUP,
      PICKUP_MANAGEMENT_MODES.UNVOID_PICKUP,
      PICKUP_MANAGEMENT_MODES.NO_FREIGHT_PICKUP,
    ].includes(mode);
    const disabledRequiredLG =[
      PICKUP_MANAGEMENT_MODES.VOID_PICKUP,
      PICKUP_MANAGEMENT_MODES.UNVOID_PICKUP,
      PICKUP_MANAGEMENT_MODES.NO_FREIGHT_PICKUP,
    ].includes(mode);
    const isMergePickupModeSelected = isMergePickupMode(mode)
    let [isDriverArrivedAtMergePickupStop, showDriverDetails] = [false, false];
    const isDisabledEditShipper = this.isDisabledEditShipper();
    if (isMergePickupModeSelected) {
      isDriverArrivedAtMergePickupStop = this.isDriverArrivedAtMergePickupStop();
      showDriverDetails = this.isMergePickupEditingAllowed();
    }
    const showEditReasonForm = this.isEditMode() && isDateTimeUpdated;
    const toggleError = pickupErrorInfo.swapAndDrop;
    const { voidCodeList = [], editCodeList = [] } =
      this.props.DispatchStore.staticClientData?.clientCodes ?? {};
    if (!pickupInfo) {
      return (
        <div id="appContainer">
          <AppLoading />
        </div>
      );
    }
    return (
      <div className={classes.dialogMainContainer} id="mainContainer">
        <div className={`${classes.contentContainer} customScroll`}>
          <Grid container>
            <Grid item xs={4} className={classes.leftPanelContainer}>
              <ShipperInfoForm
                shipperInfo={pickupInfo.shipperInfo}
                shipperErrorInfo={pickupErrorInfo.shipperInfo}
                specialInstructions={pickupInfo.specialInstructions}
                terminals={terminals}
                userProfile={this.props.userData.userProfile}
                selectedTerminal={selectedTerminal}
                selectedTerminalOffset={selectedTerminalOffset}
                handleTerminalChange={this.handleTerminalChange}
                getTerminalRef={this.getTerminalInputRef}
                updateFormData={this.updateFormData}
                updateSelectedShipperDataOnSearch={this.updateSelectedShipperDataOnSearch}
                isShipperSearched={isShipperSearched}
                mode={mode}
                selectedTerminalError={selectedTerminalError}
                searchFieldError={searchFieldError}
                isReadOnly={isReadOnlyPickupViewMode(mode) || this.isReadOnlyPickupMergeMode}
                isDisabledEditShipper={isDisabledEditShipper}
                pickupId = {pickupInfo.pickupId}
                disableSpecialInstructions={this.isReadOnlyPickupMergeMode}
              />
            </Grid>
            <Grid item xs={8} className={classes.rightPanelContainer}>
              <PickupTypeToggles
                mode={mode}
                pickupInfo={pickupInfo}
                isAssignedPickup={pickupData?.driverId}
                toggleError={toggleError}
                handlePickupTypeToggle={this.handlePickupTypeToggle}
                handleKeyDownPickTypeToggle={this.handleKeyDownPickTypeToggle}
                classes={classes}
                isExhibitPickupInMergeMode={this.state.isExhibitPickupInMergeMode}
                isReadOnlyPickupMergeMode={this.isReadOnlyPickupMergeMode}
              />
             
              {shipperList.length > 0 && (
                <Grid item xs={12}>
                  <SelectShipperForm
                    shipperList={shipperList}
                    selectedShipper={selectedShipper}
                    handleShipperSelection={this.handleShipperSelection}
                    isShipperSearched={isShipperSearched}
                  />
                </Grid>
              )}
              
              {showDriverDetails && (
                <Grid item xs={12}>
                  <DriverDetails
                    drivers={this.props.DispatchStore.activeDriversList}
                    selectedDriver={selectedDriver}
                    handleDriverChange={this.handleDriverChange}
                    driverRoute={driverRoute}
                    showTrailerScac={this.props.configJSON.showTrailerScac}
                  />
                </Grid>
              )}
              <Grid item xs={12}>
                <PickupInfo
                  mode={mode}
                  pickupErrorInfo={pickupErrorInfo.pickupDateTimeInfo}
                  pickupInfo={pickupInfo.pickupDateTimeInfo}
                  updateFormData={this.updateFormData}
                  userProfile={this.props.userData.userProfile}
                  selectedTerminalOffset={selectedTerminalOffset}
                  pickupData={pickupData}
                  shipperInfo={pickupInfo?.shipperInfo}
                  updateSpecialInstructions={this.updateSpecialInstructions}
                  configJSON={this.props.configJSON}
                  routeMappingData={this.props.DispatchStore.routeMappingData?.slice()}
                  isReadOnlyPickupMergeMode={this.isReadOnlyPickupMergeMode}
                />
              </Grid>
              {isCreateOrEditPickupMode(mode) && (
                <Grid item xs={12}>
                  <DuplicatePickupChecker
                    terminalCode={this.props.userData.userProfile.terminal.code}
                    getSelectedPickupsByIds={this.getSelectedPickupsByIds}
                    editPickup={this.props.editPickup}
                    mergePickup={this.props.mergePickup}
                    pickupData={pickupData}
                    mode={mode}
                    enablePickupEdit={this.enablePickupEdit}
                    {...getDuplicatePickupCheckerParams({ pickupInfo, selectedTerminal, selectedTerminalError, pickupErrorInfo })}
                  />
                </Grid>
              )}
              <RequiresLG
                handleChange={this.updateFormData}
                isLiftGate={pickupInfo.isLiftGate}
                disabled = {disabledRequiredLG || this.isReadOnlyPickupMergeMode}
              />
              <Grid item xs={12}>
                <ShipmentInfoForm
                  shipmentInfo={{
                    shipments: pickupInfo.shipmentInfo,
                    shipmentsErrors: pickupErrorInfo.shipmentInfo
                  }}
                  handleChange={this.updateFormData}
                  title="ShipmentsGrid"
                  onGridReady={this.onGridReady}
                  mode={mode}
                  shipmentGridError={shipmentGridError}
                  getPickupShipments={() => this.getPickupShipments(pickupInfo)}
                  isReadOnlyPickupMergeMode={this.isReadOnlyPickupMergeMode}
                />
              </Grid>
              {showBillingForm && (
                <Grid item xs={12}>
                  <BillingForm
                    mode={mode}
                    billingInfo={pickupInfo.billingInfo}
                    updateFormData={this.updateFormData}
                  />
                </Grid>
              )}
              {showEditReasonForm && (
                <Grid item xs={12}>
                  <EditReasonForm
                    editCodeList={editCodeList}
                    editReasonInfo={pickupInfo.editReasonInfo}
                    editReasonErrorInfo={pickupErrorInfo.editReasonInfo}
                    updateFormData={this.updateFormData}
                    isDateTimeUpdated={isDateTimeUpdated}
                  />
                </Grid>
              )}
              {mode === PICKUP_MANAGEMENT_MODES.NO_FREIGHT_PICKUP  && (
                <Grid item xs={12}>
                  <NoFreightInfo
                    noFreightPickupData={this.state.noFreightPickup}
                    updateNoFreightPickup={this.updateNoFreightPickup}
                  />
                </Grid>
              )}
              {mode === PICKUP_MANAGEMENT_MODES.VOID_PICKUP && (
                <Grid item xs={12}>
                  <VoidPickup
                    voidCodeList={voidCodeList}
                    glEventHub={this.props.glEventHub}
                    pickupId={pickupData.pickupId}
                    handleClose={handleClose}
                    updateVoidPickup={this.updateVoidPickup}
                    voidPickupData={this.state.voidPickup}
                  />
                </Grid>
              )}
              {mode === PICKUP_MANAGEMENT_MODES.UNVOID_PICKUP && (
                <Grid item xs={12}>
                  <UnvoidPickup
                    glEventHub={this.props.glEventHub}
                    pickupId={pickupData.pickupId}
                    handleClose={handleClose}
                    updateUnvoidPickup={this.updateUnvoidPickup}
                    unvoidPickupData={this.state.unvoidPickup}
                  />
                </Grid>
              )}
            </Grid>
          </Grid>
        </div>
        {error && <ErrorContainer message={error} />}
        <Grid className={classes.actionContainer}>
          <Warning
            mode={mode}
            warning={this.warning ?? {}}
            hasWarning={hasWarning}
            overrideWarning={overrideWarning}
            onToggleWarningOverride={this.onToggleWarningOverride}
          />
          <PanelAction
            handleClose={handleClose}
            confirmButtonText={getConfirmationButtonLabel(mode, selectedDriver)}
            handleSubmit={this.onSubmitButtonClicked()}
            isLoading={this.state.isLoading}
            isDisabled={this.isDisabledConfirmButton({ isMergePickupModeSelected, isDriverArrivedAtMergePickupStop })}
            disableMsg={
              isDriverArrivedAtMergePickupStop
                ? FORM_VALIDATION_MSG.MERGE_PICKUP_DRIVER_ARRIVED_SHIPPER_LOC
                : null
            }></PanelAction>
        </Grid>
      </div>
    );
  }
}

export default compose(
  withUserProfile,
  withStyles(styles),
  withSnackbar,
  WithModal,
  withFeatureFlags,
  withAppConfig,
)(PickupManagementForm);
